function CertificateAdjuster() {}
CertificateAdjuster.prototype.checkQuotes = function (str) {
	var result = 0,
		i = 0;
	for (i; i < str.length; i++) if (str[i] === '"') result++;
	return !(result % 2);
};

CertificateAdjuster.prototype.extract = function (from, what) {
	var certName = '';

	var begin = from.indexOf(what);

	if (begin >= 0) {
		var end = from.indexOf(', ', begin);
		while (end > 0) {
			if (this.checkQuotes(from.substr(begin, end - begin))) break;
			end = from.indexOf(', ', end + 1);
		}
		certName = end < 0 ? from.substr(begin) : from.substr(begin, end - begin);
	}

	return certName;
};

CertificateAdjuster.prototype.Print2Digit = function (digit) {
	return digit < 10 ? '0' + digit : digit;
};

CertificateAdjuster.prototype.GetCertDate = function (paramDate) {
	var certDate = new Date(paramDate);
	return (
		this.Print2Digit(certDate.getUTCDate()) +
		'.' +
		this.Print2Digit(certDate.getUTCMonth() + 1) +
		'.' +
		certDate.getFullYear() +
		' ' +
		this.Print2Digit(certDate.getUTCHours()) +
		':' +
		this.Print2Digit(certDate.getUTCMinutes()) +
		':' +
		this.Print2Digit(certDate.getUTCSeconds())
	);
};

CertificateAdjuster.prototype.GetCertName = function (certSubjectName) {
	return this.extract(certSubjectName, 'CN=');
};

CertificateAdjuster.prototype.GetIssuer = function (certIssuerName) {
	return this.extract(certIssuerName, 'CN=');
};

CertificateAdjuster.prototype.GetCertInfoString = function (
	certSubjectName,
	certFromDate
) {
	return (
		this.extract(certSubjectName, 'CN=') +
		'; Выдан: ' +
		this.GetCertDate(certFromDate)
	);
};


export default CertificateAdjuster;
